import { motion } from 'framer-motion';
import { whyChooseUsData } from '../../../mocks/services';

const WhyChooseSection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/eb851a7a419cb1d5a257887f3feeec12.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/90 via-primary-dark/85 to-primary-dark/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-accent/20 backdrop-blur-sm border border-accent/30 text-accent px-4 py-2 rounded-full text-sm font-semibold mb-4">
            NOTRE ENGAGEMENT
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
            Votre Partenaire Logistique
            <br />
            de Confiance
          </h2>
          <p className="text-white/80 text-lg max-w-2xl mx-auto">
            Nous mettons notre expertise et notre réseau au service de votre réussite avec des solutions logistiques fiables et innovantes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUsData.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="text-center"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-accent/20 backdrop-blur-sm rounded-full mx-auto mb-6 border border-accent/30">
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
              <p className="text-white/80 text-sm leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-accent mb-2">10+</div>
            <div className="text-white/90 font-medium">Années d'Expérience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-accent mb-2">5000+</div>
            <div className="text-white/90 font-medium">Expéditions Réussies</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 text-center">
            <div className="text-4xl font-bold text-accent mb-2">500+</div>
            <div className="text-white/90 font-medium">Clients Satisfaits</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
